import { notifications, showNotification } from '@mantine/notifications';
import {
  QueryClient,
  UseQueryOptions,
  UseMutationOptions,
  DefaultOptions,
  MutationCache,
} from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { ToastIconComponent } from '@/components/ToastIconComponent/ToastIconComponent';
import storage from '@/utils/storage';

const queryConfig: DefaultOptions = {
  queries: {
    // useErrorBoundary: (error: any) => error.response?.status >= 500,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    retry: 1,
    staleTime: 0,
  },
};

const mutationCache = new MutationCache({
  onError: (error: any, data: any) => {
    try {
      if (data?.vpa) {
        return false;
      }
      if (error.response.status >= 500) {
        if (error.response.status === 502) {
          storage.setItem('IS_SERVER_OFFLINE', true);
          return;
        }
        if (error.response.status === 504) {
          storage.setItem('IS_SERVER_TIMEOUT', true);
          return;
        }
        if (error?.response?.data?.message) {
          showNotification({
            title: '',
            message: error.response.data.message,
            icon: ToastIconComponent(),
          });
          notifications.cleanQueue();
          return;
        }
        return;
      }
      if (error.response.status < 500) {
        storage.setItem('IS_SERVER_OFFLINE', false);
        storage.setItem('IS_SERVER_TIMEOUT', false);
      }
      if (error?.response?.data?.message && !error?.response.data?.error_code) {
        showNotification({
          title: '',
          message: error.response.data.message,
          icon: ToastIconComponent(),
        });
      }
    } catch (error) {
      console.log('error', error);
    }
  },
});

export const queryClient = new QueryClient({
  defaultOptions: queryConfig,
  mutationCache,
});

export type ExtractFnReturnType<FnType extends (...args: any) => any> = Awaited<ReturnType<FnType>>;

export type QueryConfig<QueryFnType extends (...args: any) => any> = Omit<
  UseQueryOptions<ExtractFnReturnType<QueryFnType>>,
  'queryKey' | 'queryFn'
>;

export type MutationConfig<MutationFnType extends (...args: any) => any> = UseMutationOptions<
  ExtractFnReturnType<MutationFnType>,
  AxiosError,
  Parameters<MutationFnType>[0]
>;
